<template>
	<div id="verifyEmail" class="row justify-content-md-center">
		<div class="col-auto text-center my-3">
			<h1 class="text-center">Verify Email</h1>
			<div class="alert alert-success">
				{{status}}
			</div>
			<router-link :to="{name:'login'}" class="btn btn-primary my-2">Login Now</router-link>
		</div>  
	</div>
</template>

<script>

import { postVerifyEmail } from "@/network/signupRequests";


export default {
	name: "VerifyEmail",
	components: {
		
	},
	data() {
		return {
			status: "Verifying email"
		};
	},
	created() {

		//get key from url
		//TODO handle no key
		let verificationKey = this.$route.query.verificationKey
		postVerifyEmail({verificationKey}, () =>{ //success
			this.status = "Success verifying your email, please login now"
				setTimeout(() => {
					this.$gtm.trackEvent({
						event: 'createAccount',
					});
					this.$router.push({name:'login'})
				}, 1000);
			}, errorMsg =>{ //error message if set
				if(typeof errorMsg === 'string'){
					this.status = errorMsg
				}else{
					this.status = "Error verifying your email"
				}
			})
	},
};
</script>

<style lang="scss" scoped>
</style>
